import { useQuery, useValidSession } from "@neru/base/hooks";
import {
  type APIParams,
  type GetEntityResponse,
  type GetProductReleasesQuery,
  ProductType_Enum,
} from "@neru/base/types";
import { getAccountId } from "@neru/base/utils";
import { gql } from "graphql-request";

interface GetReleasesResponse extends GetEntityResponse {
  data?: GetProductReleasesQuery["Products"][number] & {
    isLive: boolean;
    isPublic: boolean;
  };
}

export const releaseQuery = (accountId?: string | null) => {
  const filterIsLive = `status: { _eq: live }`;
  return accountId
    ? `_or: [
          { Product: { owner: { _eq: "${accountId}" } } },
          { ${filterIsLive} }
        ]`
    : filterIsLive;
};

export const useGetReleasesQuery = (params: APIParams): GetReleasesResponse => {
  const GET_RELEASES_QUERY = gql`
    query getProductReleases($where: Products_bool_exp) {
      Products(where: $where, limit: 1) {
        name
        owner
        type
        ProductVersion {
          id
        }
        Releases: ProductVersions(
          where: {${releaseQuery(useValidSession() ? getAccountId() : null)}}
          order_by: [{ updated_at: desc }]
        ) {
          status
          version
          release_notes
          updated_at 
        }
      }
    }
  `;

  const { data, error, isValidating } = useQuery<GetProductReleasesQuery>(
    GET_RELEASES_QUERY,
    { ...params },
  );

  return {
    data: data?.Products.map(({ ProductVersion, ...rest }) => ({
      ...rest,
      isLive: Boolean(ProductVersion),
      isPublic: rest.type === ProductType_Enum.Public,
    }))[0],
    error: error?.message,
    loading: isValidating,
  };
};
